import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Percent } from "lucide-react";
import DualSlider from "./dual-slider";

const formatCurrency = (value) => {
  return "$" + formatNumber(value);
};

const formatNumber = (value, decimals = 0) => {
  if (isNaN(value) || !isFinite(value)) {
    return decimals > 0 ? (0).toFixed(decimals) : "0";
  }
  return value.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export function ProfitDistributionCard({
  profitValues,
  setProfitValues,
  results,
  profitA,
  profitB,
  profitC,
}) {
  return (
    <Card className="shadow-md">
      <CardHeader className="p-4 sm:p-6">
        <CardTitle className="flex items-center gap-2 text-base sm:text-lg md:text-xl">
          <Percent className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
          Extra Proceeds Distribution
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 pt-0">
        <p className="text-xs sm:text-sm font-semibold text-gray-800 mb-4">
          Extra proceeds distribution is the allocation of leftover profits
          after all costs, debts, and agreed returns have been paid in a deal or
          investment.
        </p>
        <DualSlider values={profitValues} onChange={setProfitValues} />
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-6">
          <div className="text-center flex flex-col items-center">
            <div
              className={`inline-block w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full ${
                results.ownerProfit >= 0 ? "bg-blue-100" : "bg-red-100"
              } flex items-center justify-center mb-3`}
            >
              <div>
                <p
                  className={`text-base sm:text-lg md:text-xl font-bold ${
                    results.ownerProfit >= 0 ? "text-blue-600" : "text-red-600"
                  }`}
                >
                  {formatCurrency(results.ownerProfit)}
                </p>
                <p className="text-xs sm:text-sm text-gray-600">{profitA}%</p>
              </div>
            </div>
            <p className="font-medium text-sm sm:text-base text-gray-800">
              Owner
            </p>
          </div>
          <div className="text-center flex flex-col items-center">
            <div
              className={`inline-block w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full ${
                results.investorProfit >= 0 ? "bg-green-100" : "bg-red-100"
              } flex items-center justify-center mb-3`}
            >
              <div>
                <p
                  className={`text-base sm:text-lg md:text-xl font-bold ${
                    results.investorProfit >= 0
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {formatCurrency(results.investorProfit)}
                </p>
                <p className="text-xs sm:text-sm text-gray-600">{profitB}%</p>
              </div>
            </div>
            <p className="font-medium text-sm sm:text-base text-gray-800">
              Investor
            </p>
          </div>
          <div className="text-center flex flex-col items-center">
            <div
              className={`inline-block w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full ${
                results.agentProfit >= 0 ? "bg-purple-100" : "bg-red-100"
              } flex items-center justify-center mb-3`}
            >
              <div>
                <p
                  className={`text-base sm:text-lg md:text-xl font-bold ${
                    results.agentProfit >= 0
                      ? "text-purple-600"
                      : "text-red-600"
                  }`}
                >
                  {formatCurrency(results.agentProfit)}
                </p>
                <p className="text-xs sm:text-sm text-gray-600">{profitC}%</p>
              </div>
            </div>
            <p className="font-medium text-sm sm:text-base text-gray-800">
              Developer
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
